var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGoogleMobileEventPeople = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 8,
  height: 6,
  viewBox: "0 0 8 6",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M5.5 4c1.493 0 1.806.38 2.48 1 .014.275.018.57.02.767V6H3s0-.447.024-.779C3.804 4.474 3.509 4 5.5 4M2 3c1.174 0 1.31.235 1.641.638.045.054-.656.14-.88.464-.226.33-.523.898-.523.898H0v-.106c.002-.152.007-.44.024-.673C.467 3.471.509 3 2 3m3.5-3a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3M2 .5a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
})));
export default SvgGoogleMobileEventPeople;